import { useEffect, useState } from "react";
import { RequestsServicesProps } from "../../../@types/requests";
import { getAtendentes, getHistoryServices } from "../../../services/requests";
import { CardFooterCustom, CustomButton, FilterContainer } from "./style";
import { FaFilter } from "react-icons/fa";
import { MdCleaningServices } from "react-icons/md";
import Paginate from "../../../Components/Paginate";
import FiltersServices from "../components/FiltersServices";
import TableServices from "../components/TableServices";
import { TbListSearch } from "react-icons/tb";

const initialFilters = {
  status: [],
  status_atual: [],
  model: {
    label: '',
    value: ''
  },
  createdData: '',
  dataFim: '',
  service: '',
  orgao: {
    label: '',
    value: ''
  },
  title: '',
  organSelected: 0,
  organSlugSelected: '',
  cpf: '',
  data: '',
  protocol: '',
  flowSlug: '',
  servicoSlug: {
    label: '',
    value: ''
  },
  atendente: [],
  setor: '',
  dataInicio: '',
};

interface ServicesTabProps {
  filtersService: any,
  setFiltersService: any
}


const Services = ({ setFiltersService }: ServicesTabProps) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<RequestsServicesProps | undefined>();
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState(initialFilters);
  const [dataAtendentes, setDataAtendentes] = useState([]);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [isCurrentStatusChecked, setIsCurrentStatusChecked] = useState(false);


  const fetchData = async ({ page }: { page: number }) => {
    setLoading(true);
    try {
      let response;
      const params = {
        page,
        search: search,
        orgao: filters.orgao.value,
        modelo: filters.model.value,
        servico: '',
        created_at: filters.createdData,
        titulo: filters.title,
        data_inicio: filters.dataInicio,
        data: filters.data,
        data_fim: filters.dataFim,
        protocolo: filters.protocol,
        atendente: filters.atendente,
        status_atual: filters.status_atual,
        servico_slug: filters.servicoSlug.value,
        cpf: filters.cpf.replace(/[.-]/g, ''),
      };
      response = await getHistoryServices(filters.status, params);
      const responseAtendentes = await getAtendentes();
      setData(response.data);
      setDataAtendentes(responseAtendentes.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setFiltersService(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => {
    fetchData({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch]);

  const clearFilters = () => {
    setFilters(initialFilters);
    setIsCurrentStatusChecked(false)
    setTriggerFetch(prev => !prev);
  };

  return (
    <>
      <FiltersServices dataAtendentes={dataAtendentes} setFilters={setFilters} filters={filters} isCurrentStatusChecked={isCurrentStatusChecked} setIsCurrentStatusChecked={setIsCurrentStatusChecked}/>
      <FilterContainer>
        <CustomButton variant="filter" onClick={() => fetchData({ page: 1 })}>
          <FaFilter size={20} /> Filtrar
        </CustomButton>
        <CustomButton variant="clear" onClick={() => clearFilters()} >
          <MdCleaningServices size={20} /> Limpar
        </CustomButton>
      </FilterContainer>

      {filters.servicoSlug.label && (
        <>
          <span style={{ margin: '24px 8px 24px 0px' }}>Resultado da busca por:</span><b>{filters.servicoSlug.label}</b>
        </>
      )}
      <div className="d-flex align-items-center">
        <TbListSearch size="20" className="text-primary mr-2" />
        <strong style={{ marginRight: '5px', marginLeft: '3px' }}>{data?.count}</strong>
        <span>Atendimentos encontrados</span>
      </div>
      <TableServices loading={loading} results={data?.results} />
      <CardFooterCustom>
        {data?.total_pages > 0 && (
          <Paginate
            flowData={data}
            setPage={fetchData}
            page={data?.current}
          />
        )}
      </CardFooterCustom>
    </>
  )
}

export default Services